/**
 * Etiquetas oficiales de iTPV/Openbravo tomadas de pos_messages_es.properties.
 *
 * Los identificadores legacy (cheque, magcard, REASON, etc.) forman parte del
 * contrato con la base de datos. Estas funciones solo traducen su presentación.
 */

export const PAYMENT_TAB_LABELS = Object.freeze({
  cash: 'Efectivo',
  cashrefund: 'Devolución Efectivo',
  cheque: 'Tarjeta',
  chequerefund: 'Tarjeta Devuelto',
  free: 'Transfer',
  magcard: 'Dinero Elect',
  magcardrefund: 'Dinero Elect',
  paper: 'Vale',
  monedero: 'Monedero',
  debt: 'A cuenta',
});

export const TRANSACTION_PAYMENT_LABELS = Object.freeze({
  monedero: 'Monedero electrónico',
  cash: 'Ventas en Efectivo',
  cashin: '(Entrada) Efectivo',
  cashout: '(Salida) Efectivo',
  cashrefund: 'Devolución Efectivo',
  cheque: 'Tarjeta Bancaria',
  chequerefund: 'Devolución con Tarjeta Bancaria',
  free: 'Transferencia',
  magcard: 'Dinero Electrónico',
  magcardrefund: 'Devolución con Dinero Electrónico',
  paper: 'Vale',
  paperin: 'Vales cobrados',
  paperout: 'Devolución Vales',
  debt: 'A cuenta',
  debt_total: 'Total a cuenta pagados',
  debtpaid: 'A cuenta pagados',
  debtpaid_pen: 'A cuenta pendiente',
});

export const STOCK_MOVEMENT_LABELS = Object.freeze({
  1: '(entrada) compra',
  2: '(entrada) devolución',
  4: '(entrada) Traspaso',
  '-1': '(salida) venta',
  '-2': '(salida) devolución',
  '-3': '(salida) merma',
  '-4': '(salida) Traspaso',
  1000: 'Traspaso',
});

const normalizePaymentType = (paymentType) => String(paymentType || '').trim().toLowerCase();

export const paymentTabLabel = (paymentType) => {
  const key = normalizePaymentType(paymentType);
  return PAYMENT_TAB_LABELS[key] || paymentType || '-';
};

export const transactionPaymentLabel = (paymentType) => {
  const key = normalizePaymentType(paymentType);
  return TRANSACTION_PAYMENT_LABELS[key] || PAYMENT_TAB_LABELS[key] || paymentType || '-';
};

export const stockMovementLabel = (reason) => (
  STOCK_MOVEMENT_LABELS[String(reason)] || `Razón ${reason}`
);
